import { ACTIVE_SERVER_ID, ESHOP_URL } from 'mk/settings';

export const homepageUrl = '/';

export const eshopWithChannelUrl = {
    201: `${ESHOP_URL}sk-eur/sk`,
    202: `${ESHOP_URL}cz-czk/cs`,
}[ACTIVE_SERVER_ID];

